import { isUnauthorized as e, startSignIn as t, useSessionQuery as n } from "@frontends/data-access-spg-auth";
import { DsAlert as r, DsButton as i, DsHeading as a } from "@frontends/ds";
import { useState as o } from "react";
import { useTranslation as s } from "react-i18next";
import { Navigate as c, Outlet as l, useLocation as u, useSearchParams as d } from "react-router";
import { jsx as f, jsxs as p } from "react/jsx-runtime";
import { UiKitEmptyState as m } from "@frontends/ui-kit";
//#region src/lib/constants.ts
var h = "feature-spg-auth", g = "sign-in-return-to";
function _(e) {
	return e !== null && e.startsWith("/") && !e.startsWith("//");
}
function v(e) {
	try {
		_(e) ? sessionStorage.setItem(g, e) : sessionStorage.removeItem(g);
	} catch {}
}
function y() {
	try {
		let e = sessionStorage.getItem(g);
		return sessionStorage.removeItem(g), _(e) ? e : null;
	} catch {
		return null;
	}
}
//#endregion
//#region src/lib/LoginPage.tsx
var b = ["rejected", "unavailable"];
function x(e) {
	return b.find((t) => t === e) ?? null;
}
function S() {
	let { t: e } = s(h), [l] = d(), u = n(), [m, g] = o(!1), [y, b] = o(!1), S = l.get("next");
	if (u.isSuccess) return /* @__PURE__ */ f(c, {
		to: _(S) ? S : "/",
		replace: !0
	});
	let C = x(l.get("error")), w = async () => {
		g(!0), b(!1), v(S);
		try {
			await t();
		} catch {
			g(!1), b(!0);
		}
	};
	return /* @__PURE__ */ f("main", {
		className: "flex min-h-dvh items-center justify-center p-6",
		children: /* @__PURE__ */ p("div", {
			className: "flex w-full max-w-sm flex-col gap-6",
			children: [
				/* @__PURE__ */ f(a, {
					level: 1,
					children: e("title")
				}),
				C !== null && /* @__PURE__ */ f(r, {
					variant: "danger",
					description: e(`errors.${C}`)
				}),
				y && /* @__PURE__ */ f(r, {
					variant: "danger",
					description: e("errors.unavailable")
				}),
				/* @__PURE__ */ f(i, {
					size: "lg",
					isPending: m,
					onPress: () => void w(),
					children: e("signIn")
				})
			]
		})
	});
}
//#endregion
//#region src/lib/RequireAuth.tsx
function C({ loginPath: t }) {
	let { t: r } = s(h), i = n(), a = u();
	if (i.isPending) return null;
	if (i.isError) {
		if (e(i.error)) {
			let e = `${a.pathname}${a.search}`;
			return /* @__PURE__ */ f(c, {
				to: {
					pathname: t,
					search: `?next=${encodeURIComponent(e)}`
				},
				replace: !0
			});
		}
		return /* @__PURE__ */ f("main", {
			className: "p-6",
			children: /* @__PURE__ */ f(m, {
				icon: "server-off",
				title: r("unavailable"),
				actionLabel: r("retry"),
				onAction: () => void i.refetch()
			})
		});
	}
	return /* @__PURE__ */ f(l, {});
}
//#endregion
//#region src/lib/SignedInRedirect.tsx
function w(e) {
	let t = y();
	return t && t !== "/" ? t : e;
}
function T({ fallback: e }) {
	let [t] = o(() => w(e));
	return /* @__PURE__ */ f(c, {
		to: t,
		replace: !0
	});
}
//#endregion
export { h as FEATURE_SPG_AUTH_NAMESPACE, S as LoginPage, C as RequireAuth, T as SignedInRedirect };
